
import "../Foundation/stylable/spacing.st.css.js";
import "../BaseModalLayout/BaseModalLayout.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_109_2_AnnouncementModalLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_109_2_AnnouncementModalLayout__root","announcementModalLayout":"wds_1_109_2_AnnouncementModalLayout__announcementModalLayout","link":"wds_1_109_2_AnnouncementModalLayout__link","bottomSpacing":"wds_1_109_2_AnnouncementModalLayout__bottomSpacing"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




